import { mergeProps } from "@base-ui/react/merge-props";
import { useRender } from "@base-ui/react/use-render";
import { colors, typo } from "@obs/tokens/index.stylex.ts";
import type { StyleXStyles } from "@stylexjs/stylex";
import * as stylex from "@stylexjs/stylex";

export type TypographyPrimitiveProps = {
	sx?: StyleXStyles;
	inheritColor?: boolean;
	inverted?: boolean;
} & useRender.ComponentProps<"p">;

const styles = stylex.create({
	base: {
		margin: 0,
		fontFamily: typo.fontFamily,
		color: colors.neutralTxtDefault,
	},
	inheritColor: {
		color: "inherit",
	},
	inverted: {
		color: colors.neutralTxtInverted,
	},
});

export const TypographyPrimitive = ({ render, sx, inheritColor = false, inverted = false, ...props }: TypographyPrimitiveProps & { inverted?: boolean }) => {
	return useRender({
		render,
		defaultTagName: "p",
		props: mergeProps<"p">(props, stylex.props(styles.base, inheritColor && styles.inheritColor, inverted && styles.inverted, sx)),
	});
};
